import { render, staticRenderFns } from "./consents-table.vue?vue&type=template&id=eee34c14&scoped=true"
import script from "./consents-table.vue?vue&type=script&lang=js"
export * from "./consents-table.vue?vue&type=script&lang=js"
import style0 from "./consents-table.vue?vue&type=style&index=0&id=eee34c14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eee34c14",
  null
  
)

export default component.exports